'use strict';

function PerformanceReviewOverviewController(performanceReviewService, $window, $log, $location) {
  var INVITE_STATES = {
    COMPLETED: 'initial_completed',
    PENDING: 'initial_pending',
    STARTED: 'initial_started',
  };
  var vm = this;

  vm.$onInit = $onInit;
  vm.showInterview = showInterview;
  vm.useNewCode = useNewCode;
  vm.isCommonAssessmentOpen = isCommonAssessmentOpen;
  vm.followUp = {
    useFollowUp: useFollowUp,
    goToFollowUp: goToFollowUp,
    getFollowUpStateDisplay: getFollowUpStateDisplay,
    getIcon: getFollowUpIcon,
    getBtnClass: getFollowUpBtnClass
  };
  vm.initialAssessment = {
    useNewInitial: useNewInitial,
    goToNewInitial: goToNewInitial,
    getNewInitialStateDisplay: getNewInitialStateDisplay,
    getIcon: getInitialIcon,
    getBtnClass: getInitialBtnClass
  };

  function useNewInitial(invite) {

    if (invite.follow_up) {
      if (invite.follow_up.state === 'follow_up_ready') {
        if (invite.follow_up.coworker_doc_url) {
          // previous completed follow up exists
          return false;
        }
        return true;
      }
      return false;
    }

    if (!invite.initial_assessment) {
      return false;
    }
    return true;
  }

  function useNewCode(invite) {
    if (invite.initial_assessment) {
      return true;
    }

    if (invite.follow_up) {
      if (invite.follow_up.state === 'follow_up_ready') {
        if (invite.follow_up.coworker_doc_url) {
          // previous completed follow up exists
          return true;
        }
        return false;
      }
      return true;
    }

    return false;
  }

  function goToNewInitial(invite) {

    if (invite.initial_assessment) {
      var url = invite.initial_assessment.coworker_doc_url;
      $window.location.href = url;
    }
  }

  function getNewInitialStateDisplay(invite) {
    if (!invite.initial_assessment) {
      return 'Error';
    }
    return invite.initial_assessment.button_text;
  }

  function getInitialIcon(invite) {

    if (!invite.initial_assessment) {
      return 'fa fa-circle-exclamation';
    }

    if (invite.initial_assessment.state === INVITE_STATES.COMPLETED) {
      return 'fa fa-check';
    }

    return 'fa fa-comment';

  }

  function getInitialBtnClass(invite) {
    if (!invite.initial_assessment) {
      return 'btn btn-xs btn-new danger';
    }

    if (invite.initial_assessment.state === INVITE_STATES.COMPLETED) {
      return 'btn btn-xs btn-success';
    }
    return 'btn btn-xs btn-default';
  }


  function $onInit() {
    useFollowUpTime();
  }

  function useFollowUpTime() {
    vm.invites.forEach(function (invite) {
      if (invite.follow_up) {
        if (invite.follow_up.appointment_datetime) {
          invite.transpire = invite.follow_up.appointment_datetime;
        }
      }
    });
  }

// function _getTokenUrl(service, token) {
//   return service.urls.questionnaire.step({ token: token, step: 'intro' });
// }

  function useFollowUp(invite) {
    if (!invite.follow_up) {
      return false;
    }
    if (invite.follow_up.state === 'follow_up_ready') {
      if (invite.follow_up.coworker_doc_url) {
        // previous completed follow up exists
        return true;
      }
      return false;
    }
    return true;
  }

  function goToFollowUp(invite) {
    if (invite.follow_up) {
      var url = invite.follow_up.coworker_doc_url;
      $window.location.href = url;
    }
  }

  function getFollowUpStateDisplay(invite) {
    if (!invite.follow_up) {
      return 'Error';
    }
    return invite.follow_up.button_text;
  }

  function getFollowUpIcon(invite) {
    if (!invite.follow_up) {
      return 'fa fa-circle-exclamation';
    }
    if (invite.follow_up.state === 'follow_up_ready') {
      if (invite.follow_up.coworker_doc_url) {
        return 'fa fa-check';
      }
    }
    return 'fa fa-undo';

  }

  function getFollowUpBtnClass(invite) {
    if (!invite.follow_up) {
      return 'btn btn-xs btn-new danger';
    }
    if (invite.follow_up.state === 'follow_up_ready') {
      if (invite.follow_up.coworker_doc_url) {
        return 'btn btn-xs btn-success';
      }
    }
    return 'btn btn-xs btn-default';
  }


  function showInterview(inviteIndex) {
    // var invite = vm.invites[inviteIndex];
    // if (invite.initial_assessment) {
    //   var url = invite.initial_assessment.coworker_doc_url;
    //   $window.location.href = url;
    //   return;
    // }

    var token = vm.invites[inviteIndex].token;
    var assessments = vm.me.token.all_assessments.filter(function (assessment) {
      return assessment.token === token;
    })[0];
    var url = _getAssessmentTokenUrl(performanceReviewService, assessments);
    $location.path(url);
  }

  function _getAssessmentTokenUrl(service, token) {
    if ((vm.isCommonAssessmentOpen(token.transpire) && token.is_lockable) || token.review) {
      return service.urls.agreement.questionnaire.base({token: token.token});
    }
    return service.urls.questionnaire.step({token: token.token, step: 'intro'});
  }

  function isCommonAssessmentOpen(transpire) {
    return new Date(transpire).getTime() < new Date().getTime();
  }
}

module.exports = PerformanceReviewOverviewController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-overview/performance-review-overview.controller.js
 ** module id = 311
 ** module chunks = 0
 **/